export interface NavigationLink {
    id: string;
    name: string;
    url: string;
    external?: boolean;
}

export const navigationLinks: NavigationLink[] = [
    {
        id: 'rca',
        name: 'Verifica valabilitate RCA',
        url: 'https://www.aida.info.ro/polite-rca',
        external: true,
    },
    {
        id: 'itp',
        name: 'Verifica valabilitate ITP',
        url: 'https://prog.rarom.ro/rarpol/',
        external: true,
    },
    {
        id: 'rovinieta',
        name: 'Verifica valabilitate Rovigneta',
        url: 'https://www.cnadnr.ro/ro/verificare-rovinieta',
        external: true,
    },
];

export const footerLinks: NavigationLink[] = [
    {
        id: 'about',
        name: 'Despre noi',
        url: '#about',
    },
    {
        id: 'contact',
        name: 'Contact',
        url: '#contact-popup',
    },
    {
        id: 'petitii',
        name: 'Petitii',
        url: 'https://www.renomia.ro/informatii-utile#form-solidpixels-1',
        external: true,
    },
];
